import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['stationSelect', 'reporterSelect']
  static values = {
    reportersByStation: Object,
    initialReporterId: String,
    initialStation: String,
    reporterDefaultPrompt: String,
  }

  connect() {
    if (this.hasInitialStationValue && this.initialStationValue)
      this.stationSelectTarget.value = this.initialStationValue

    this.updateReporters(this.initialReporterIdValue)
  }

  updateReporters(reporterIdToSelect) {
    const selectedStation = this.stationSelectTarget.value
    this._populateReporters(selectedStation, reporterIdToSelect)
  }

  _clearReporters() {
    const reporterSelect = this.reporterSelectTarget

    while (reporterSelect.firstChild) {
      reporterSelect.removeChild(reporterSelect.firstChild)
    }
  }

  _populateReporters(selectedStation, reporterIdToSelect) {
    const reporters = this.reportersByStationValue[selectedStation] || []
    const reporterSelect = this.reporterSelectTarget

    this._clearReporters()

    reporterSelect.appendChild(
      this._createOption('', this.reporterDefaultPromptValue)
    )

    reporters.forEach(reporter =>
      reporterSelect.appendChild(
        this._createOption(`${reporter.id}`, reporter.name)
      )
    )

    if (
      reporterIdToSelect &&
      Array.from(reporterSelect.options).some(
        opt => opt.value === reporterIdToSelect
      )
    ) {
      reporterSelect.value = reporterIdToSelect
      reporterSelect.disabled = true
    } else {
      reporterSelect.value = ''
      reporterSelect.disabled = !selectedStation
    }
  }

  _createOption(value, content) {
    const option = document.createElement('option')
    option.value = value
    option.textContent = content

    return option
  }
}
